export default "__VITE_ASSET__49ff0f1f__"